
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-md w-full mx-auto p-8 bg-white rounded-lg shadow-lg text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Check className="h-8 w-8 text-green-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
        <p className="text-gray-600 mb-6">
          Thank you for your payment. Your transaction has been completed successfully.
        </p>
        
        <div className="space-y-4">
          {/* <Button 
            variant="default" 
            className="w-full py-2"
            onClick={() => navigate('/dashboard')}
          >
            <Home className="mr-2 h-4 w-4" />
            Go to Dashboard
          </Button>
           */}
          <div className="text-sm text-gray-500">
            A confirmation has been sent to your email address.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
